import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import hopscotch from 'hopscotch';
import Tour from 'config/Tour';

import { Icon} from 'components';

class Navbar extends Component {
  handleStartTour = () => {
    hopscotch.startTour(Tour);
  };

  render() {
    return (
      <div className="navbar-custom">
        <div className="container-fluid">
          <div id="navigation">
            <div className="row">
              <div className="col-10">
                <ul className="navigation-menu">
                  <li className="has-submenu">
                    <Link to="/"  className="link">
                      <Icon name="cart" />
                      <span>Dashboard</span>
                    </Link>
                  </li>

                  <li className="has-submenu">
                    <Link to="/example" className="link">
                      <Icon name="arrow-right" />
                      <span>Exemplo</span>
                    </Link>
                  </li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Navbar;
